module.exports = __webpack_public_path__ + "img/hr-stack-filter-inserter-hand-base.0edb747f.png";